import React from 'react';
import { makeStyles } from '@material-ui/core';
import backgroundImage from './cover.jpg';
import footerImage from './FZlogofooter.png';
import flowChartImage from './flowchart.jpg';

const useStyle = makeStyles((theme) => ({
  root: {
  },
  header: {
    display: 'flex',
  },
  body: {
    fontSize: 18,
    background: '#d19859',
    color: '#000000',
    padding: theme.spacing(4),

    '& $ul': {
      margin: 0,
    },
    '& $ol': {
      marginBottom: 0,
    },
    '& $ul, & $ol': {
      paddingInlineStart: '24px',
    },
    '& $ol $li::marker, & $ul $li::marker': {
      color: '#000000',
    },
  },
  button: {
    color: '#000000',
    background: '#000000',
    borderRadius: 16,
    display: 'block',
    fontSize: 26,
    fontWeight: 'bold',
    marginTop: theme.spacing(4),
    padding: theme.spacing(1),
    textAlign: 'center',
    textDecoration: 'none',
    width: '100%',

    '&:visited': {
      color: 'rgb(249,190,0)',
    },
  },
  hr: {
    borderTop: '2px solid #000000',
    margin: theme.spacing(2, 0),
  },
  item: {
    '& + &': {
      marginTop: theme.spacing(2),
    },
  },
  title: {
    fontWeight: 'bold',
  },
  description: {
  },
  footer: {
    background: 'rgb(111,61,31)',
    padding: theme.spacing(4, 0),
    textAlign: 'center',
  },
}));

export default () => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <img src={backgroundImage} width="100%" alt="" />
      </div>
      <div className={classes.body}>
        <div style={{
          fontWeight: 'bold',
          marginTop: 16,
          color: '#ffffff',
        }}
        >
          【活動期間】
        </div>
        <div
          style={{
            fontSize: 18,
            fontWeight: 'bold',
          }}
        >
          2022/11/30 (三) 至 2022/12/31 (日)
        </div>
        <div style={{
          fontWeight: 'bold',
          marginTop: 16,
          color: '#ffffff',
        }}
        >
          【如何兌換】
        </div>
        <div>
          本活動使用「自由食間」迷你無人商店自動販售及派樣，開放每人免費兌換1瓶（一瓶以上將依照售價 39 元/瓶自動結帳扣款）。請依照下列步驟獲得取貨碼兌換：
        </div>
        <div
          style={{
            fontWeight: 'bold',
            marginTop: 8,
            color: '#ffffff',
          }}
        >
          我是已註冊會員
        </div>
        <ol style={{ marginTop: 0 }}>
          <li>點擊下方按鈕，直接LINE登入自由食間。</li>
          <li>填寫會員資料，或直接點擊「資料更新」。</li>
          <li>LINE收到成功通知。</li>
          <li>前往活動機台，選擇「預購取貨」並「輸入取貨碼」。</li>
        </ol>
        <div
          style={{
            fontWeight: 'bold',
            marginTop: 8,
            color: '#ffffff',
          }}
        >
          我是新用戶
        </div>
        <ol style={{ marginTop: 0 }}>
          <li>點擊下方按鈕，開始註冊。</li>
          <li>完成註冊後，LINE收到成功通知。</li>
          <li>前往「我的取貨碼」查看六位數字動態取貨碼。</li>
          <li>至活動機台，依照平板畫面指示，刷卡或LINE Pay掃碼，並輸入電話號碼。</li>
          <li>選擇「預購取貨」並「輸入取貨碼」</li>
          <li>開啟冰箱門免費領取1瓶，即可關門離開。</li>
        </ol>
        <ul style={{ marginTop: 16 }}>
          <li style={{ backgroundColor: 'red', color: 'white' }}>
            重要！請務必加入自由食間LINE才會收到成功通知！
          </li>
          <li style={{ backgroundColor: 'red', color: 'white' }}>
            重要！每人免費兌換1瓶（一瓶以上將依照售價 39 元/瓶自動結帳扣款）
          </li>
          <li style={{ backgroundColor: 'red', color: 'white' }}>重要！取貨時務必點選【預購取貨】並且【輸入取貨碼】才開門，如因流程錯誤造成購買扣款不予退貨，敬請見諒。</li>
        </ul>
        <a href="/user/profile" className={classes.button} target="_blank">獲得取貨碼</a>
        <div className={classes.hr} />
        <div style={{ fontWeight: 'bold' }}>指定兌換地點</div>
        <div className={classes.hr} />
        <div style={{ fontSize: 16 }}>[雙北]</div>
        {[
          { name: '中正凱撒世貿中心店', address: '台北市中正區忠孝東路一段85號 一樓大門' },
          { name: '信義環球世貿店', address: '台北市信義區信義路五段150巷2號 B2中庭' },
          { name: '內湖中興工程店', address: '台北市內湖區新湖二路280號' },
          { name: '內湖中華賓士店', address: '台北市內湖區瑞光路360號 1樓販賣機區' },
          { name: '內湖時代廣場店', address: '台北市內湖區瑞光路258巷2號 1樓販賣機區' },
          { name: '土城享享群青店', address: '新北市土城區裕華街25號 1樓大廳' },
          { name: '松山亞洲企業中心店', address: '台北市松山區民權東路三段142-144號 1樓大廳' },
          { name: '大直LINE Pay總部店', address: 'LINE Pay總部 13樓接待大廳（不對外開放）' },
          { name: '內湖內科之心店', address: '內科之心B棟 3樓茶水間（不對外開放）' },
          { name: '中山TaskUs店', address: 'TaskUs Taiwan 5樓交誼空間（不對外開放）' },
          { name: '信義台北101店', address: '台北101 35樓 Sky Park（不對外開放）' },
          { name: '信義誠品總公司店', address: '台北市信義區松德路204號 B1樓梯旁' },
          { name: '板橋遠東Tpark店', address: '新北市板橋區遠東路1號' },
          { name: '內湖聯詠科技店', address: '聯詠科技總部 9樓（不對外開放）' },
          { name: '信義沛星科技店', address: '沛星科技 8樓（不對外開放）' },
          { name: '大同CLBC店', address: '台北市大同區承德路三段287-2號A棟' },
          { name: '南港91APP店', address: '台北市南港區八德路四段768巷5號3樓' },
        ].map(({ name, address }) => (
          <div className={classes.item}>
            <div className={classes.title}>{name}</div>
            <div className="description">{address}</div>
          </div>
        ))}
        <div style={{ fontSize: 16, marginTop: 16 }}>[新竹]</div>
        {[
          { name: '寶山聯詠研發大樓店', address: '新竹縣寶山鄉創新一路13號' },
          { name: '寶山聯詠科技大樓店', address: '新竹縣寶山鄉創新一路1-2號' },
          { name: '東區科技財經大樓店', address: '新竹市東區光復路二段289號 1樓大廳' },
        ].map(({ name, address }) => (
          <div className={classes.item}>
            <div className={classes.title}>{name}</div>
            <div className="description">{address}</div>
          </div>
        ))}
        <img src={flowChartImage} alt="" width="100%" style={{ marginTop: 16 }} />
        <a href="/user/profile" className={classes.button} target="_blank">獲得取貨碼</a>
      </div>
      <div className={classes.footer}>
        <img src={footerImage} width="250" alt="" />
      </div>
    </div>
  );
};
